import { z } from 'zod';
export const orgMembershipRolesResponseSchema = z
    .object({
    membership: z
        .object({
        id: z.string().uuid(),
        userId: z.string().uuid(),
        organizationId: z.string().uuid(),
        primaryRoleId: z.string().uuid(),
        roleIds: z.array(z.string().uuid()),
        createdAt: z.string(),
        updatedAt: z.string(),
    })
        .strict(),
    effective_permissions_preview: z
        .object({
        organizationId: z.string().uuid(),
        slugs: z.array(z.string()),
    })
        .strict(),
})
    .strict();
//# sourceMappingURL=org-membership-roles-response.schema.js.map